import React, { Component } from 'react';
import { Query } from 'react-apollo';
import DeleteJob from './components/DeleteJob'
import { LIST_JOB } from './components/queries';
import ShowMoreText from 'react-show-more-text';
import { Multiselect } from 'multiselect-react-dropdown';
import { constRef } from "./constants";


class ListOfJobs extends Component {

  state = {
    skills: []
  }
  onSelect = (skills, selectedItem) => {
    this.setState({ skills: skills.toString() });
  }

  onRemove = (skills, selectedItem) => {
    this.setState({ skills: skills.toString() });
  }
  static increaseCount(count) {
    ListOfJobs.filteredCount = count;
  }


  render() {

    let filteredData = [];

    return (
      <div className="scrollable-panel">
        <div className="row">
          <div className="col-2">

          </div>
          <div className="col-8">
            <Multiselect id="multiskills_app" required
              options={constRef.optionsRef}
              displayValue="key"
              onSelect={this.onSelect}
              onRemove={this.onRemove}
              placeholder="Search Jobs by Skills"
              isObject={false}
              style={constRef}
              selectionLimit={1}
              ref={this.multiselectRef}
            />
          </div>
          <div className="col-2">

          </div>
        </div>
        <br />
        <h5> Scrolldown for more jobs...</h5>
        <Query query={LIST_JOB}>

          {({ loading, error, data }) => {
            if (loading) return "Loading...";
            if (error) return (console.log(error));
            if (data.fl_jobs.length >= 1) {
              filteredData = data.fl_jobs.filter(fl_job => this.state.skills.length >= 1 ? (fl_job.skills.includes(this.state.skills.toString()) ? fl_job : "") : fl_job);

             if (filteredData.length >= 1) {  
              return filteredData.map((fl_job) => (

                <div className="card text bg-light m-5">
                  <div className="card-header">
                    <h3><p className="card-text text"> <span key={fl_job.id} ><i className="fa fa-plus-circle" aria-hidden="true"></i>  {fl_job.title}  {/*<DeleteJob id={id} />*/}</span></p></h3>
                  </div>
                  <div className="card-body ">

                    <div className="card-deck">
                      <div className="card">
                        <ul className="list-group">
                          <li className="list-group-item list-group-item"><h5><i className="fa fa-user fa-2x" aria-hidden="true"></i> User : {fl_job.user}</h5></li>
                          <li className="list-group-item list-group-item"><h5><i className="fa fa-money fa-2x" aria-hidden="true"></i>   Budget : {fl_job.budget} {fl_job.currency}</h5></li>
                          <li className="list-group-item list-group-item"><h5><i className="fa fa-clock-o fa-2x" aria-hidden="true"></i>  Submitted on  : {fl_job.time}</h5></li>
                          {/*<li className="list-group-item list-group-item"><h5><i className="fa fa-phone-square fa-2x" aria-hidden="true"></i>  Contact  : {contact}</h5></li>*/}

                          <li className="list-group-item list-group-item"><h5><i className="fa fa-phone-square fa-2x" aria-hidden="true"></i>  Contact  : {fl_job.contact}
                            <a className="fa fa-whatsapp icon" href={
                              "https://api.whatsapp.com/send?phone=" + fl_job.contact} target="_blank"></a></h5></li>

                          <li className="list-group-item list-group-item"><h5><i className="fa fa-check-square fa-2x" aria-hidden="true"></i>  Skills  : {fl_job.skills.split(",").join(", ")} </h5></li>

                        </ul>
                      </div>
                      <div className="card " >
                        <h5 className="card-header bg-dark text-white"> <i className="fa fa-sticky-note" aria-hidden="true"></i>  Description</h5>
                        <div className="card-body">
                          <h5>
                            <ShowMoreText
                              lines={3}
                              more='Show more'
                              less='Show less'
                              anchorclassName=''

                              expanded={false}
                              width={280}
                            >
                              {fl_job.description}
                            </ShowMoreText>
                          </h5>
                        </div>
                      </div>
                    </div>


                  </div>

                </div>

              ));

            }
            else {
              return  <div className="card  m-3 pb-2">
                <div className="card-body">
                  <p className="card-text text-danger"> <h4><i className="fa  fa-envelope fa-1x" aria-hidden="true">  Jobs List is Empty with this Criteria...</i></h4></p>
                </div>
              </div>
              
            }
            }
            else {
              return  <div className="card  m-3 pb-2">
                <div className="card-body">
                  <p className="card-text text-danger"> <h2><i className="fa  fa-envelope fa-1x" aria-hidden="true">  Jobs List is Empty...</i></h2></p>
                </div>
              </div>
              
            }

          }}

        </Query>
      </div >
    )
  }
}

export default ListOfJobs;
